import { render, staticRenderFns } from "./ContentParametersCascaderWrapper.vue?vue&type=template&id=5844d682&"
import script from "./ContentParametersCascaderWrapper.vue?vue&type=script&lang=js&"
export * from "./ContentParametersCascaderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports